const openFile = (blob, filetype) => {
  const fileBlob = new Blob([blob], { type: filetype })
  const url = URL.createObjectURL(fileBlob)
  window.open(url)
}

export default openFile
